import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'
//import Register from '../views/Register'
//import Login from '../views/Login'
//import Domains from '../views/Domains'
//import Instances from '../views/Instances'
//import DNS from '../views/DNS'
//import Mail from '../views/Mail'

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {title: 'Harborwall - Dashboard'},
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
    meta: { guest: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { guest: true }
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('../views/Domain.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('../views/AccountSettings.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/notifications',
    name: 'AccountNotifcations',
    component: () => import('../views/AccountNotifications.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/instances',
    name: 'Instances',
    component: () => import('../views/Instances.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/domains',
    name: 'Domains',
    component: () => import('../views/Domains.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/domains/:domain_id',
    name: 'Domain',
    component: () => import('../views/Domain.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/domains/:domain_id/settings',
    name: 'DomainSettings',
    component: () => import('../views/DomainSettings.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/domains/:domain_id/dns',
    name: 'DNS',
    component: () => import('../views/DNSRecords.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/domains/:domain_id/dns/records',
    name: 'DNSRecords',
    component: () => import('../views/DNSRecords.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/domains/:domain_id/dns/settings',
    name: 'DNSSettings',
    component: () => import('../views/DNSRecords.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/domains/:domain_id/mail',
    name: 'MailHome',
    component: () => import('../views/MailHome.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/domains/:domain_id/mail/accounts',
    name: 'MailAccounts',
    component: () => import('../views/MailAccounts.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/domains/:domain_id/mail/aliases',
    name: 'MailAliases',
    component: () => import('../views/MailAliases.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/domains/:domain_id/mail/forwards',
    name: 'MailForwards',
    component: () => import('../views/MailForwards.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/domains/:domain_id/mail/settings',
    name: 'MailSettings',
    component: () => import('../views/MailSettings.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: () => import('../views/AdminDashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    component: () => import('../views/AdminUsers.vue'),
    meta: { requiresAuth: true }
  },
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.auth.status.loggedIn) {  // store.getters.isAuthenticated
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.state.auth.status.loggedIn) {  // store.getters.isAuthenticated
      next('/domains')
      return
    }
    next()
  } else {
    next()
  }
})

const DEFAULT_TITLE = 'Harborwall Management';
router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    document.title = to.meta.title || DEFAULT_TITLE;
});

export default router
